import api from '../api';
import { useRequestImmer } from '../api/hooks';
import { Page } from './common';
import { User } from './user';

export const MoremeEndpoint = `/moreme`;

export interface MoremeClient {
  age: number;
  cgcount: number;
  cname: 'ST';
  createtime: string;
  diseaseList: string[];
  id: number;
  userId: number;
  image: string;
  lastCgid: number;
  sex: number;
}

export interface MoremeReport {
  addTime: string;
  imgPrefix: string;

  blackheadNum: number;
  blackheadPercentage: number;
  blackheadSize: number;
  mainImg: string;
  faceType: number;
  id: number;
  moremeCgid: number;
  moremeCid: number;
  poreNum: number;
  pornPercentage: number;
  score: number;
  skinAge: number;
  stainNum: number;
  stainPercentage: number;
  wrinkleLength: number;
  wrinkleNum: number;
  wrinklePercentage: number;
  sensativityArea: number;
  sensativityAreaPercentage: number;
  stainArea: number;

  blackheadMaskImg: string;
  poreMaskImg: string;
  sensativityMaskImg: string;
  stainMaskImg: string;
  wrinkleMaskImg: string;
}

export const useFetchMoremeClientList = () =>
  useRequestImmer<{
    list: MoremeClient[];
    page: Page;
  }>(
    {
      url: `${MoremeEndpoint}` + '/client',
      method: 'get',
    },
    {
      manual: true,
    }
  );

export const bindMoremeClientToUser = (data: {
  moremeCid: number;
  wecomId?: string;
  username?: string;
}) =>
  api.post<User>({
    url: MoremeEndpoint + '/bindUser',
    data,
  });

export const syncReport = () =>
  api.get({
    url: MoremeEndpoint + '/sync/report',
  });

export const useFetchMoremeClientName = () =>
  useRequestImmer<string>(
    {
      method: 'get',
      url: `${MoremeEndpoint}/client/{username}/name`,
    },
    {
      manual: true,
    }
  );

export const getReportImg = (prefix: string, type: string, width?: number) => {
  const baseUrl = `${prefix}${type}.jpg`;
  if (width) {
    return `${baseUrl}?x-oss-process=image/resize,w_${width}`;
  }
  return baseUrl;
};

export const requestUserMoremeReportList = () =>
  useRequestImmer<{ list: MoremeReport[]; page: Page }>(
    {
      url: `${MoremeEndpoint}/user/{username}/report`,
      method: 'get',
    },
    {
      manual: true,
    }
  );

export const getReportDetailExternal = async (moremeCgid: string | number) => {
  return await fetch(
    `https://metisapi.imoreme.com/analysisReport/findSharePageReport?cgid=${moremeCgid}&language=zh`
  );
};
